import { HelpCircleIcon, PhoneIcon } from 'lucide-react-native';
import { YStack } from 'tamagui';

import { MemberTip } from '../../components/MemberTip/MemberTip';

export const MemberTips = () => {
    return (
        <YStack gap={16}>
            <MemberTip
                icon={HelpCircleIcon}
                text="Have questions about Direct Deposit or switching your bills? Reach out to our team with any questions!"
                button={{
                    text: '(833) 700-4052',
                    onPress: () => {},
                    icon: PhoneIcon,
                }}
            />
            <MemberTip
                icon={HelpCircleIcon}
                text="Your Money Map assumes $12,000 of income landing in your Fruitful accounts each month. Get started by switching your Direct Deposit to Fruitful."
            />
        </YStack>
    );
};
